export default "__VITE_ASSET__B4uiA8mC__"